import {
    drawerWidth,
    drawerMiniWidth,
    transition,
    boxShadow,
    defaultFont,
    primaryColor,
    primaryBoxShadow,
    infoColor,
    successColor,
    warningColor,
    dangerColor,
    roseColor,
    whiteColor,
    blackColor,
    grayColor,
    hexToRgb,
} from '../../material-dashboard-pro-react.js';

const sidebarStyle = (theme) => ({
    drawerPaperRTL: {
        left: 'auto !important',
        right: '0 !important',
    },
    drawerPaper: {
        border: '1px solid var(--spara-sidebar-border, #f2abb6)',
        borderRadius: '16px',
        position: 'fixed',
        top: '16px',
        bottom: '16px',
        left: '16px',
        zIndex: '1032',
        transitionProperty: 'top, bottom, width',
        transitionDuration: '.2s, .2s, .35s',
        transitionTimingFunction: 'linear, linear, ease',
        boxShadow: 'none',
        overflow: 'hidden',
        width: drawerWidth,
        '@media (max-width: 599px)': {
            width: 'calc(100vw - 32px)',
            maxWidth: '350px',
            left: '16px',
            top: '16px',
            bottom: '16px',
            borderRadius: '16px',
            height: 'calc(100% - 32px)',
            overflow: 'hidden',
        },
        '@media (min-width: 600px)': {
            width: drawerWidth,
            position: 'fixed',
            height: 'calc(100% - 32px)',
            borderRadius: '16px',
            boxShadow: '2px 0 8px var(--spara-border-subtle, rgba(222,44,72,0.1))',
        },
        '&:before,&:after': {
            position: 'absolute',
            zIndex: '3',
            width: '100%',
            height: '100%',
            content: '""',
            display: 'block',
            top: '0',
        },
    },
    blackBackground: {
        color: 'var(--spara-sidebar-fg, #de2c48)',
        '&:after': {
            background: 'var(--spara-sidebar-bg, #f8d5da)',
            opacity: 1,
            borderRadius: '16px',
        },
    },
    blueBackground: {
        color: whiteColor,
        '&:after': {
            background: infoColor[0],
            opacity: '.93',
        },
    },
    whiteBackground: {
        color: grayColor[2],
        '&:after': {
            background: whiteColor,
            opacity: '.93',
        },
    },
    whiteAfter: {
        '&:after': {
            backgroundColor: 'hsla(0,0%,71%,.3) !important',
        },
    },
    drawerPaperMini: {
        width: drawerMiniWidth + 'px!important',
    },
    logo: {
        padding: '8px 0px',
        margin: '0',
        display: 'block',
        position: 'relative',
        zIndex: '4',
    },
    logoMini: {
        transition: 'all 300ms linear',
        opacity: 1,
        float: 'left',
        textAlign: 'center',
        width: '100%',
        display: 'inline-block',
        maxHeight: '45px',
        marginLeft: '0',
        marginRight: '0',
        marginTop: '0',
        color: 'inherit',
    },
    logoMiniRTL: {
        float: 'right',
        marginRight: '30px',
        marginLeft: '26px',
    },
    a: {
        textDecoration: 'none',
    },
    logoNormal: {
        ...defaultFont,
        transition: 'all 300ms linear',
        display: 'block',
        opacity: '1',
        transform: 'translate3d(0px, 0, 0)',
        padding: '5px 0px',
        fontSize: '18px',
        whiteSpace: 'nowrap',
        fontWeight: '400',
        lineHeight: '30px',
        overflow: 'hidden',
        textDecoration: 'none',
        '&,&:hover,&:focus': {
            color: 'inherit',
        },
    },
    logoNormalRTL: {
        textAlign: 'right',
    },
    logoNormalSidebarMini: {
        transform: 'translate3d(0, 0, 0)',
        textAlign: 'center',
    },
    logoNormalSidebarMiniRTL: {
        transform: 'translate3d(25px, 0, 0)',
    },
    img: {
        width: '50px',
        position: 'relative',
        left: 'calc(50% - 50px/2)',
    },
    img_main: {
        position: 'relative',
        width: '100px',
        left: 'calc(50% - 100px/2)',
    },
    img_mini: {
        width: '32px',
        position: 'relative',
        float: 'right',
    },
    background: {
        position: 'absolute',
        zIndex: '1',
        height: '100%',
        width: '100%',
        display: 'block',
        top: '0',
        left: '0',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        transition: 'all 300ms linear',
    },
    list: {
        marginTop: '15px',
        paddingLeft: '15px',
        paddingTop: '0',
        paddingBottom: '0',
        marginBottom: '0',
        listStyle: 'none',
        color: 'inherit',
        '&:before,&:after': {
            display: 'table',
            content: '" "',
        },
        '&:after': {
            clear: 'both',
        },
    },
    item: {
        color: 'inherit',
        position: 'relative',
        display: 'block',
        textDecoration: 'none',
        margin: '0',
        padding: '0',
    },
    userItem: {
        '&:last-child': {
            paddingBottom: '0px',
        },
    },
    itemLink: {
        transition: 'all 300ms linear',
        margin: '4px 12px 0 0',
        borderRadius: '8px',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        padding: '0 14px',
        height: '44px',
        backgroundColor: 'transparent',
        ...defaultFont,
        width: 'auto',
        textDecoration: 'none',
        '&:hover': {
            outline: 'none',
            backgroundColor: 'rgba(255,255,255,0.3)',
            boxShadow: 'none',
        },
        '&,&:hover,&:focus': {
            color: 'inherit',
        },
    },
    itemIcon: {
        color: '#de2c48',
        opacity: '0.8',
        width: '30px',
        height: '24px',
        flexShrink: '0',
        marginRight: '15px',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    itemIconRTL: {
        float: 'right',
        marginLeft: '15px',
        marginRight: '1px',
    },
    itemText: {
        color: 'inherit',
        ...defaultFont,
        margin: '0',
        lineHeight: '22px',
        fontSize: '14px',
        transform: 'translate3d(0px, 0, 0)',
        opacity: '1',
        transition: 'transform 300ms ease 0s, opacity 300ms ease 0s',
        position: 'relative',
        display: 'block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: '0 16px 0 0 !important',
    },
    userItemText: {
        lineHeight: '22px',
    },
    itemTextRTL: {
        marginRight: '45px',
        textAlign: 'right',
    },
    itemTextMini: {
        transform: 'translate3d(-25px, 0, 0)',
        opacity: '0',
        flex: '0 0 0px',
        minWidth: '0',
        padding: '0 !important',
        overflow: 'hidden',
    },
    itemLinkMini: {
        margin: '4px 6px 0 6px !important',
        padding: '0 !important',
        height: '44px !important',
        display: 'flex !important',
        alignItems: 'center',
        justifyContent: 'center',
    },
    itemIconMini: {
        float: 'none !important',
        marginRight: '0 !important',
    },
    listMini: {
        paddingLeft: '0',
        paddingRight: '0',
        marginTop: '8px',
    },
    itemTextMiniRTL: {
        transform: 'translate3d(25px, 0, 0) !important',
    },
    collapseList: {
        marginTop: '2px',
        marginLeft: '8px',
        paddingLeft: '0px',
        borderLeft: '2px solid rgba(222,44,72,0.18)',
        '& $caret': {
            marginTop: '8px',
        },
    },
    collapseItem: {
        position: 'relative',
        display: 'block',
        textDecoration: 'none',
        margin: '2px 0 0 0',
        padding: '0',
    },
    collapseActive: {
        outline: 'none',
        backgroundColor: 'rgba(255,255,255,0.25)',
        boxShadow: 'none',
    },
    collapseItemLink: {
        transition: 'all 300ms linear',
        margin: '0 8px 0 0',
        borderRadius: '6px',
        position: 'relative',
        display: 'block',
        padding: '5px 8px',
        backgroundColor: 'transparent',
        ...defaultFont,
        width: 'auto',
        opacity: '0.85',
        '&:hover': {
            outline: 'none',
            backgroundColor: 'rgba(255,255,255,0.3)',
            boxShadow: 'none',
            opacity: '1',
        },
        '&,&:hover,&:focus': {
            color: 'inherit',
        },
    },
    collapseItemMini: {
        color: 'inherit',
        ...defaultFont,
        textTransform: 'uppercase',
        width: '30px',
        marginRight: '15px',
        textAlign: 'center',
        letterSpacing: '1px',
        position: 'relative',
        float: 'left',
        display: 'inherit',
        transition: 'transform 300ms ease 0s, opacity 300ms ease 0s',
        fontSize: '14px',
    },
    collapseItemMiniRTL: {
        float: 'right',
        marginLeft: '30px',
        marginRight: '1px',
    },
    collapseItemText: {
        color: 'inherit',
        ...defaultFont,
        margin: '0',
        position: 'relative',
        transform: 'translateX(0px)',
        opacity: '1',
        whiteSpace: 'nowrap',
        display: 'block',
        transition: 'transform 300ms ease 0s, opacity 300ms ease 0s',
        fontSize: '14px',
    },
    collapseItemTextRTL: {
        textAlign: 'right',
    },
    collapseItemTextMiniRTL: {
        transform: 'translate3d(25px, 0, 0) !important',
    },
    collapseItemTextMini: {
        transform: 'translate3d(-25px, 0, 0)',
        opacity: '0',
    },
    caret: {
        marginTop: '10px',
        position: 'absolute',
        right: '18px',
        transition: 'all 150ms ease-in',
        display: 'inline-block',
        width: '0',
        height: '0',
        marginLeft: '2px',
        verticalAlign: 'middle',
        borderTop: '4px solid',
        borderRight: '4px solid transparent',
        borderLeft: '4px solid transparent',
    },
    dropdownWrapConteiner: {
        position: 'relative',
        float: 'left',
        width: '100%',
        marginLeft: '20px',
    },
    userCaret: {
        marginTop: '10px',
    },
    caretRTL: {
        left: '11px',
        right: 'auto',
    },
    caretActive: {
        transform: 'rotate(180deg)',
    },
    purple: {
        '&,&:hover,&:focus': {
            color: whiteColor,
            backgroundColor: primaryColor[0],
            ...primaryBoxShadow,
        },
    },
    blue: {
        '&,&:hover,&:focus': {
            color: whiteColor,
            backgroundColor: infoColor[0],
            boxShadow:
                '0 12px 20px -10px rgba(' +
                hexToRgb(infoColor[0]) +
                ',.28), 0 4px 20px 0 rgba(' +
                hexToRgb(blackColor) +
                ',.12), 0 7px 8px -5px rgba(' +
                hexToRgb(infoColor[0]) +
                ',.2)',
        },
    },
    green: {
        '&,&:hover,&:focus': {
            color: whiteColor,
            backgroundColor: successColor[0],
            boxShadow:
                '0 12px 20px -10px rgba(' +
                hexToRgb(successColor[0]) +
                ',.28), 0 4px 20px 0 rgba(' +
                hexToRgb(blackColor) +
                ',.12), 0 7px 8px -5px rgba(' +
                hexToRgb(successColor[0]) +
                ',.2)',
        },
    },
    orange: {
        '&,&:hover,&:focus': {
            color: whiteColor,
            backgroundColor: warningColor[0],
            boxShadow:
                '0 12px 20px -10px rgba(' +
                hexToRgb(warningColor[0]) +
                ',.28), 0 4px 20px 0 rgba(' +
                hexToRgb(blackColor) +
                ',.12), 0 7px 8px -5px rgba(' +
                hexToRgb(warningColor[0]) +
                ',.2)',
        },
    },
    red: {
        '&,&:hover,&:focus': {
            color: 'var(--spara-primary, #de2c48)',
            backgroundColor: 'var(--spara-sidebar-active-bg, rgba(255,255,255,0.55))',
            boxShadow: '0 2px 8px var(--spara-border-subtle, rgba(222,44,72,0.15))',
            fontWeight: '600',
        },
    },
    white: {
        '&,&:hover,&:focus': {
            color: grayColor[2],
            backgroundColor: whiteColor,
            boxShadow:
                '0 4px 20px 0 rgba(' +
                hexToRgb(blackColor) +
                ',.14), 0 7px 10px -5px rgba(' +
                hexToRgb(grayColor[2]) +
                ',.4)',
        },
    },
    rose: {
        '&,&:hover,&:focus': {
            color: whiteColor,
            backgroundColor: roseColor[0],
            boxShadow:
                '0 4px 20px 0 rgba(' +
                hexToRgb(blackColor) +
                ',.14), 0 7px 10px -5px rgba(' +
                hexToRgb(roseColor[0]) +
                ',.4)',
        },
    },
    sidebarWrapper: {
        position: 'relative',
        height: 'calc(100vh - 75px - 32px)',
        overflow: 'auto',
        width: '100%',
        zIndex: '4',
        overflowScrolling: 'touch',
        transitionProperty: 'top, bottom, width',
        transitionDuration: '.2s, .2s, .35s',
        transitionTimingFunction: 'linear, linear, ease',
        color: 'inherit',
        paddingBottom: '30px',
    },
    sidebarWrapperWithPerfectScrollbar: {
        overflow: 'hidden !important',
    },
    user: {
        paddingBottom: '0',
        margin: '0',
        position: 'relative',
    },
    photo: {
        transition: 'all 300ms linear',
        width: '34px',
        height: '34px',
        overflow: 'hidden',
        float: 'left',
        zIndex: '5',
        marginRight: '11px',
        borderRadius: '50%',
        marginLeft: '23px',
        border: '2px solid rgba(222,44,72,0.2)',
        boxShadow: 'none',
    },
    photoRTL: {
        float: 'right',
        marginLeft: '12px',
        marginRight: '24px',
    },
    avatarImg: {
        width: '100%',
        verticalAlign: 'middle',
        border: '0',
    },
    userCollapseButton: {
        margin: '0',
        padding: '6px 15px',
        '&:hover': {
            background: 'none',
        },
    },
    userCollapseLinks: {
        marginTop: '-4px',
    },
    active: {
        backgroundColor: primaryColor[0],
        color: whiteColor,
        boxShadow: primaryBoxShadow,
    },
});

export default sidebarStyle;
